export default __webpack_public_path__ + "static/media/logo-ld.6d1b06d7.webp";